<template>
    <fieldset
        class="card"
        :style="{ maxWidth: width, background: backgroundColor }"
    >
        <legend>{{ title }}</legend>
        <v-checkbox
            class="checkbox"
            v-if="!hideCheckbox"
            v-model="select"
            color="#8585FF"
        ></v-checkbox>
        <div class="card-content">
            <v-col class="img-col" sm="3">
                <div class="img-container">
                    <img :src="img" alt="Card image" />
                    <slot name="img-footer"></slot>
                </div>
            </v-col>
            <v-col
                v-for="(item, itemIndex) in data"
                :key="`item${itemIndex}`"
                class="data-cols"
                :sm="columnSize"
            >
                <div class="text">
                    <h2 v-if="item.title">{{ item.title }}</h2>
                    <p
                        v-for="(prop, propIndex) in item.props"
                        :key="`prop${propIndex}`"
                    >
                        {{ prop.name }}:
                        <slot name="prop" :prop="prop"
                            ><span>{{ prop.value }}</span></slot
                        >
                    </p>
                </div>
            </v-col>
        </div>
        <div class="actions">
            <slot name="actions"></slot>
        </div>
    </fieldset>
</template>

<script>
export default {
    name: 'info-card',
    props: {
        data: {
            type: Array,
            required: true
        },
        value: {
            required: false,
            default: null
        },
        title: {
            type: String,
            required: false
        },
        img: {
            type: String,
            required: false,
            default: './img/shopping-bag.png'
        },
        hideCheckbox: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            required: false,
            default: '100%'
        },
        backgroundColor: {
            type: String,
            required: false,
            default: '#fff'
        },
        columnSize: {
            type: String,
            required: false,
            default: '2'
        }
    },
    data() {
        return {
            select: false,
            selectedValue: this.value ?? this.data
        }
    },
    watch: {
        select: {
            handler: function(val) {
                this.$emit('select', this.selectedValue, val)
            }
        }
    }
}
</script>

<style scoped>
.card {
    position: relative;
    margin: 0 auto; /* Added */
    color: rgba(0, 0, 0, 0.87);
    border: 1px;
    box-shadow: 0 10px 16px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%) !important;
    border-radius: 4px;
}
legend,
h2 {
    font-weight: bold;
}
.img-container {
    text-align: center;
    max-width: 100%;
    background-size: cover;
    margin-bottom: 10px;
}
.img-container > img {
    width: 80%;
}
.actions,
.checkbox {
    position: absolute;
}
.v-icon {
    cursor: pointer;
}
.v-icon:hover {
    background-color: #ccc;
}
@media (min-width: 601px) {
    .card-content {
        white-space: nowrap;
        overflow: auto;
    }
    .img-col,
    .data-cols {
        display: inline-block;
        vertical-align: top;
    }
    legend {
        font-size: calc(0.8vw + 0.8vh + 0.8vmin);
    }
    h2 {
        font-size: calc(0.6vw + 0.6vh + 0.6vmin);
    }
    p {
        font-size: calc(0.4vw + 0.4vh + 0.3vmin);
    }
    .v-input {
        display: inline-block;
        width: 60%;
    }
    .actions,
    .checkbox {
        top: 30%;
    }
    .actions {
        right: 10px;
    }
    .checkbox {
        left: 10px;
    }
}
@media (max-width: 600px) {
    .card {
        display: flex;
        justify-content: center;
        text-align: center;
        padding-top: 100px;
    }
    .card-content {
        width: 100%;
    }
    .checkbox {
        top: 0;
    }
    .data-cols {
        border-top: 1px solid #ccc;
    }
    h2 {
        font-size: 16px;
    }
    .text {
        margin: 10px;
    }
    .actions {
        top: 60px;
    }
}
</style>
